import React from "react";
import { PiPhoneCallFill } from "react-icons/pi";

const CallButtonComponent = () => {
  const phoneNumber = "9861934932";

  return (
    <button
      className="fixed left-4 bottom-4 z-40 rounded-full shadow-lg hover:scale-105 ease-in-out duration-300 focus:outline-none transition-transform transform-gpu p-2 bg-white"
      onClick={() => (window.location.href = `tel:${phoneNumber}`)}
    >
      <PiPhoneCallFill size={36} color="#064585" />
    </button>
  );
};

export default CallButtonComponent;
